"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireWildcard(require("react"));

var _find = _interopRequireDefault(require("lodash/find"));

var _assign = _interopRequireDefault(require("lodash/assign"));

var _RenderEditableContent = _interopRequireDefault(require("./RenderEditableContent"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

// function hasActiveDirectChild(
//   content: $ContentBlocks,
//   activeComponentId?: null | string
// ): boolean {
//   return reduce(
//     content,
//     (memo, child) => {
//       return child && child.id === activeComponentId ? true : memo;
//     },
//     false
//   );
// }
var RenderChild = /*#__PURE__*/function (_Component) {
  (0, _inherits2["default"])(RenderChild, _Component);

  var _super = _createSuper(RenderChild);

  function RenderChild() {
    var _this;

    (0, _classCallCheck2["default"])(this, RenderChild);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "elementRef", void 0);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "reCalculate", function () {
      var _this$props = _this.props,
          _this$props$child = _this$props.child,
          id = _this$props$child.id,
          attrs = _this$props$child.attrs,
          _this$props$internals = _this$props.internals,
          updateComponentAttrs = _this$props$internals.updateComponentAttrs,
          editingContentId = _this$props$internals.editingContentId,
          isEditor = _this$props$internals.isEditor;

      if (isEditor && updateComponentAttrs && _this.elementRef && !editingContentId) {
        var box = _this.elementRef.getBoundingClientRect();

        var width = Math.floor(box.width);
        var height = Math.floor(box.height);

        if (attrs.calculatedWidth !== width || attrs.calculatedHeight !== height) {
          updateComponentAttrs(id, (0, _assign["default"])({}, attrs, {
            calculatedWidth: width,
            calculatedHeight: height
          }));
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "refCallback", function (element) {
      _this.elementRef = element;

      _this.reCalculate();
    });
    return _this;
  }

  (0, _createClass2["default"])(RenderChild, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.reCalculate();
    }
  }, {
    key: "render",
    value: function render() {
      var internals = this.props.internals || {};
      var components = internals.components;
      var editingContentId = internals.editingContentId;

      var child = _objectSpread({}, this.props.child);

      var isActive = editingContentId === child.id;

      if (isActive && this.props.internals.editingContentFormAttrs) {
        child.attrs = this.props.internals.editingContentFormAttrs;
      }

      var Component = (0, _find["default"])(components, {
        type: child.type
      });

      if (!(Component && Component.Render)) {
        throw new Error("Render function is undefined for ".concat(child.type));
      }

      var element = /*#__PURE__*/_react["default"].createElement(Component.Render, (0, _assign["default"])({}, this.props, {
        content: child,
        onClick: function onClick() {
          return null;
        },
        refCallback: this.refCallback,
        reCalculate: this.reCalculate
      }));

      return !this.props.internals.isEditor ? /*#__PURE__*/_react["default"].createElement(_react.Fragment, {
        key: this.props.idx
      }, element) : /*#__PURE__*/_react["default"].createElement(_RenderEditableContent["default"], {
        key: this.props.idx,
        child: child,
        parent: this.props.parent,
        internals: internals,
        isActive: isActive
      }, element);
    }
  }]);
  return RenderChild;
}(_react.Component);

var RenderContent = function RenderContent(props) {
  //$FlowIgnore
  return props.content.map(function (child, idx) {
    return (
      /*#__PURE__*/
      //$FlowIgnore
      _react["default"].createElement(RenderChild, (0, _extends2["default"])({
        child: child,
        key: idx,
        idx: idx
      }, props))
    );
  });
};

var _default = RenderContent;
exports["default"] = _default;